/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Kind/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import Person from './Person/index'
import React from 'react'
import Template from './Template/index'



/** @type {import('Simple/types.js').View} */
export default function Kind({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Referrals/Referral/Kind"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let profilePatientReferralPersonTypeValueData = fromData.useDataFormat({ viewPath,
context: 'profile_patient_referral',
path: 'person_type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: profilePatientReferralPersonTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Person'}>
<Person
  viewPath={`${viewPath}/Person`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Template'}>
<Template
  viewPath={`${viewPath}/Template`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}